// One card per component group, as the PRD groups them.
import React from 'react';
import { FiArrowRight, FiLock, FiSlash } from 'react-icons/fi';
import s from '../CTROptimizer.module.css';
import { num } from '../format';

export default function FeatureCards({ data, loading, onOpen }) {
  if (loading && !data) {
    return <div className={s.cardGrid}>{[0, 1, 2].map((i) =>
      <div key={i} className={s.cardSkeleton} />)}</div>;
  }
  if (!data?.cards?.length) return null;

  return (
    <div className={s.cardGrid}>
      {data.cards.map((card) => {
        const blocked = card.state === 'blocked';
        const clickable = card.state === 'found';
        return (
          <section key={card.key}
                   className={`${s.card} ${s[`card_${card.state}`]} ${clickable ? s.cardOpen : ''}`}
                   onClick={clickable ? () => onOpen(card.tab) : undefined}
                   role={clickable ? 'button' : undefined}
                   tabIndex={clickable ? 0 : undefined}
                   onKeyDown={clickable ? (e) => {
                     if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpen(card.tab); }
                   } : undefined}>
            <header className={s.cardHead}>
              <span className={s.cardRef}>{card.ref}</span>
              {clickable && <FiArrowRight className={s.cardGo} />}
              {blocked && <FiSlash className={s.cardLock} />}
              {card.state === 'unavailable' && <FiLock className={s.cardLock} />}
            </header>
            <h3 className={s.cardTitle}>{card.title}</h3>
            <p className={s.cardQuestion}>{card.question}</p>
            <div className={s.cardHeadline}>
              <span className={s.cardValue}>{card.headline}</span>
              {card.unit && <span className={s.cardUnit}>{card.unit}</span>}
            </div>
            <p className={s.cardDetail}>{card.detail}</p>

            {card.key === 'rate' && card.ranked != null && (
              <ul className={s.cardList}>
                <li className={s.cardNote}>
                  {num(card.ranked)} ranked · {num(card.suppressed)} held back for having
                  too few impressions to carry a rate.
                </li>
              </ul>
            )}
            {card.key === 'why' && card.causes && (
              <ul className={s.cardList}>
                {Object.entries(card.causes).map(([cause, n]) => (
                  <li key={cause}>
                    <span className={s.cardTerm}>{cause}</span>
                    <span className={s.cardFigure}>{n}</span>
                  </li>
                ))}
                {card.healthy > 0 && (
                  <li className={s.cardNote}>
                    {num(card.healthy)} products are within reach of their benchmark and
                    get no recommendation at all.
                  </li>
                )}
              </ul>
            )}
          </section>
        );
      })}
    </div>
  );
}
